import React, { useState, useEffect } from "react";

// TOC Component
export const TableOfContents = ({ content }) => {
  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    if (!content) return;
    const headingList = content
      .filter((block) => block.style && /^h[1-6]$/.test(block.style)) // Filter out blocks with heading styles (h1 to h6)
      .map((block) => {
        const text = block.children
          .map((child) => child.text || "")
          .join(" ")
          .trim();
        const id = text.replace(/\s+/g, "-").toLowerCase(); // Generate a slug for the id
        return {
          id, // If the text is not empty, use it to create an id
          text, // The heading text
          tag: block.style.toUpperCase(), // Convert the style to the corresponding tag (h1, h2, etc.)
        };
      })
      .filter((heading) => heading.text !== ""); // Exclude empty headings

    setHeadings(headingList);
  }, [content]);

  return (
    <div id="table-of-contents" className="ruffruff-table-of-contents">
      <nav className="toc-nav">
        <p className="table-of-contents-title">ON THIS PAGE</p>

        <div className="table-of-contents-body">
          <ol className="toc-body-ol">
            {headings.map((heading) => (
              <>
                <li className="table-of-contents-list-item" key={heading.id}>
                  <button
                    className="ruffruff-table-of-contents-list-item-anchor"
                    onClick={() => {
                      const element = document.getElementById(heading.id);
                      if (element) {
                        const elementPosition =
                          element.getBoundingClientRect().top +
                          window.pageYOffset;
                        const offsetPosition = elementPosition - 100;

                        window.scrollTo({
                          top: offsetPosition,
                          behavior: "smooth",
                        });
                      }
                    }}
                    href={`#${heading.id}`}
                  >
                    {heading.text}
                  </button>
                </li>
              </>
            ))}
          </ol>
        </div>
      </nav>
    </div>
  );
};
